import { lazy, Suspense, useEffect, useState } from "react";
import { MessageSquare, X } from "lucide-react";

const SevenAssistant = lazy(() =>
  import("./seven-assistant").then((m) => ({ default: m.SevenAssistant }))
);

export function SevenAssistantFloating() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      {/* Painel */}
      <div
        className={`fixed z-[60] bottom-24 right-4 md:right-8 w-[min(420px,calc(100vw-2rem))] transition-all duration-300 ${
          open
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        {open && (
          <Suspense fallback={null}>
            <SevenAssistant />
          </Suspense>
        )}
      </div>

      {/* Botão flutuante */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Fechar assistente" : "Abrir assistente"}
        className="fixed z-[61] bottom-6 right-4 md:right-8 group inline-flex items-center gap-2.5 pl-4 pr-5 py-3.5 shadow-[var(--shadow-elevation)] hover:-translate-y-0.5 transition-transform"
        style={{ backgroundColor: "var(--text-1)", color: "var(--surface)" }}
      >
        <span className="relative flex w-2 h-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        {open ? (
          <>
            <X className="w-4 h-4" />
            <span className="text-[12px] font-semibold tracking-[0.18em] uppercase">
              Fechar
            </span>
          </>
        ) : (
          <>
            <MessageSquare className="w-4 h-4" />
            <span className="text-[12px] font-semibold tracking-[0.18em] uppercase">
              Fale com a Seven
            </span>
          </>
        )}
      </button>
    </>
  );
}
